import { gql } from 'graphql-request';

export const EQUIPMENT_TYPES_QUERY = gql`
  query EquipmentTypes {
    equipmentTypes {
      title
      description
      image
    }
  }
`;

export const RECOMMENDED_EQUIPMENTS_QUERY = gql`
  query RecommendedEquipments {
    recommendedEquipments {
      id
    }
  }
`;

export const EQUIPMENT_BY_ID_QUERY = gql`
  query EquipmentById($id: String!) {
    equipment(id: $id) {
      id
      name
      images
      marketPrice
      category
      year
      flex
      brandName
    }
  }
`; 

export const EQUIPMENT_DETAIL_BY_ID_QUERY = gql`
  query EquipmentDetailById($id: String!) {
    equipment(id: $id) {
      id
      name
      images
      year
      content
      sizeChart
      marketPrice
      category
      equipmentAttrId
      commentId
      brandName
      createTime
      updateTime
      isDelete
      relatedEquipment
      viewNum
      collectionNum
      brandId
      commentNum
      totalCommentNum
      orderCommentNum
      orderCommentCoefficient
      technicalInfo
      bottomIm
      techInfoImage
      model
      gender
      wideVersion
      graphicDesign
      color
      positioning
      award
      level
      style
      camberProfile
      boardShape
      insertPattern
      shape
      stance
      baseType
      base
      edgeTech
      boardCore
      construction
      sidewall
      edge
      length
      effectiveEdge
      contactLength
      sidecutRadius
      waistWidth
      weight
      coreMaterial
      strapType
      baseMaterial
      adjustable
      highbackMaterial
      mounting
      flex
      discType
      flexIndex
      referenceWeight
      strapTech
      baseTech
      footbedTech
      highbackTech
      discTech
      linerTech
      closureTech
      upperTech
      footbed
      sole
      closureType
      upperMaterial
      gaitor
      liner
      thermoMoldable
      heatActivated
      adjustableFlex
      bootWeight
      soleType
      midsole
      boardBootStyle
      otherTech
      isCollection
    }
  }
`; 

export const CATEGORIES_QUERY = gql`
  query Categories {
    categories {
      title
      subtitle
      category
      images
    }
  }
`;

export const EQUIPMENTS_BY_CATEGORY_PAGINATED_QUERY = gql`
  query EquipmentsByCategory($category: String!, $offset: Int!, $limit: Int!) {
    equipmentsByCategory(category: $category, offset: $offset, limit: $limit) {
      id
      name
      images
      marketPrice
      category
      year
      flex
      brandName
      style
    }
  }
`;

export const EQUIPMENTS_BY_BRAND_NAME_PAGINATED_QUERY = gql`
  query EquipmentsByBrandName($brandName: String!, $offset: Int!, $limit: Int!) {
    equipmentsByBrandName(brandName: $brandName, offset: $offset, limit: $limit) {
      id
      name
      images
      marketPrice
      category
      year
      flex
      brandName
      brandId
      style
    }
  }
`;

export const SEARCH_EQUIPMENTS_QUERY = gql`
  query SearchEquipments(
    $searchText: String
    $brands: [String!]
    $categories: [String!]
    $styles: [String!]
    $minPrice: Float
    $maxPrice: Float
    $offset: Int!
    $limit: Int!
  ) {
    searchEquipments(
      searchText: $searchText
      brands: $brands
      categories: $categories
      styles: $styles
      minPrice: $minPrice
      maxPrice: $maxPrice
      offset: $offset
      limit: $limit
    ) {
      equipments {
        id
        name
        images
        marketPrice
        category
        year
        flex
        brandName
        style
        color
        model
        gender
      }
      offset
      limit
      totalCount
    }
  }
`;

export const MULTI_FIELD_SEARCH_EQUIPMENTS_QUERY = gql`
  query MultiFieldSearchEquipments(
    $searchText: String!
    $offset: Int!
    $limit: Int!
  ) {
    multiFieldSearchEquipments(
      searchText: $searchText
      offset: $offset
      limit: $limit
    ) {
      equipments {
        id
        name
        images
        marketPrice
        category
        year
        flex
        brandName
        style
        color
        model
        gender
      }
      offset
      limit
      totalCount
    }
  }
`;